<template>
  <div class="bg-blackly relative z-10 flex flex-col text-left">
    <button
      id="options-menu"
      type="button"
      class="text-br-green-light hover:text-white focus:border-blue-300 focus:ring-1 focus:ring-blue flex items-center justify-between w-full h-full px-6 fluid-xs leading-tightest uppercase transition duration-150 ease-in-out"
      :aria-expanded="open"
      aria-controls="options-menu-dropdown"
      @click="open = !open"
    >
      <div class="font-medium mr-1">{{ heading }}</div>
      <DropdownIndicatorIcon :down="!open" class="block h-1.5 -mr-1" />
    </button>
    <div v-show="open" v-on-click-outside="() => (open = false)" :aria-expanded="open" id="options-menu-dropdown">
      <div
        class="bg-blackly absolute right-0 w-full origin-top-right shadow-lg"
        role="menu"
        aria-orientation="vertical"
        aria-labelledby="options-menu"
      >
        <div
          v-for="{ title, route, slug } in options"
          :key="slug"
          class="border-t border-gray-600"
          @click="open = !open"
        >
          <nuxt-link
            :to="route"
            class="text-br-green-light hover:bg-gray-800 hover:text-white focus:text-white block px-6 py-2 fluid-xs leading-tightest leading-5"
            role="menuitem"
            >{{ title }}</nuxt-link
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mixin as onClickOutside } from 'vue-on-click-outside';
import DropdownIndicatorIcon from '@/components/icons/DropdownIndicatorIcon';

export default defineNuxtComponent({
  components: {
    DropdownIndicatorIcon,
  },
  mixins: [onClickOutside],
  props: {
    heading: {
      type: String,
      required: true,
    },
    options: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return { open: false };
  },
});
</script>
